import React from "react";
import {Button, Form, Modal, Space, message, DatePicker} from "antd";
import {connect} from "react-redux";
import {displayErrors} from "../../libs/utils";
import moment from 'moment';
import {
    adminCreateWebsiteSetupManagedHostingOrder,
    adminLoadAllInvoices
} from "../../actions/billing";

class WebsiteSetupManagedServiceOrderCreationModal extends React.Component {
    state = {
        loading: false,
        nextInvoiceDate: moment().add(1, 'year'),
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }

        return null;
    }

    closeModal(reload = false) {
        this.setState({
            loading: false,
            nextInvoiceDate: moment().add(1, 'year'),
        });

        this.props.close();

        if(reload) {
            this.props.reload();
        }
    }

    createOrder() {
        this.setState({ loading: true });

        let data = {
            next_invoice_date: this.state.nextInvoiceDate.format('YYYY-MM-DD'),
            website_setup_order: this.props.orderId
        };

        this.props.adminCreateWebsiteSetupManagedHostingOrder(this.props.orderId, data, () => {
            this.closeModal(true);
            message.success('IP address order successfully created!');
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loading: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        return(
            <Modal
                destroyOnClose={true}
                title='Create Shared Hosting Order'
                open={this.props.showModal}
                footer={<Space>
                    <Button disabled={this.state.loading} onClick={() => this.closeModal()}>Close</Button>
                    <Button disabled={this.state.loading} loading={this.state.loading} onClick={() => this.createOrder()} type='primary'>Create Order</Button>
                </Space>}
                onCancel={() => this.closeModal()}>
                <Form layout='vertical'>
                    <Form.Item label='Next invoice date'>
                        <DatePicker defaultValue={moment(this.state.nextInvoiceDate, 'YYYY-MM-DD')}
                                    format='YYYY-MM-DD'
                                    onChange={(e, _) => this.setState({ nextInvoiceDate: moment(_, ).format('YYYY-MM-DD') })} />
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

export default connect(null, { adminLoadAllInvoices, adminCreateWebsiteSetupManagedHostingOrder })(WebsiteSetupManagedServiceOrderCreationModal);